import { Button, Skeleton, Table } from "antd";
import React, { useEffect, useState } from "react";
import Dashboard from "../Layout/Dashboard";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getOrders } from "../../actions/orders";
import { formatDate } from "../../utils/Utils";

const Orders = ({ currentUser, storeCurrency }) => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const history = useNavigate();

  useEffect(() => {
    setLoading(true);
    dispatch(getOrders(currentUser.store));
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const columns = [
    {
      key: 1,
      title: "Order",
      render: (_, record) => record?.user?.name,
    },
    {
      key: 2,
      title: "Order Items",
      dataIndex: "items",
      render: (_, record) => record?.orderItems?.length,
    },
    {
      key: 3,
      title: "Status",
      render: (record) => record?.status,
    },
    {
      key: 4,
      title: "Total",
      render: (record) => (
        <p className="m-0">
          {storeCurrency} {record?.totalPrice}
        </p>
      ),
    },
    {
      key: 5,
      title: "Contact",
      dataIndex: "phone",
    },
    {
      key: 6,
      title: "Updated At",
      render: (_, record) => <p>{formatDate(record?.updatedAt)}</p>,
    },
    {
      key: 7,
      title: "Created At",
      render: (_, record) => <p>{formatDate(record?.createdAt)}</p>,
    },
  ];

  const data = useSelector((state) => state.orders);

  const onRowClick = (id) => {
    history(`/order/${id}`);
  };

  return (
    <Dashboard title="Orders">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl m-0 font-bold">Orders</h2>
        <Button type="primary" href="/order/new" htmlType="submit">
          Add Order
        </Button>
      </div>
      <div className="bg-white shadow p-4 my-4">
        <Skeleton loading={loading}>
          <Table
            className="cursor-pointer"
            columns={columns}
            scroll={{
              x: 1000,
            }}
            dataSource={data}
            rowKey={(record) => record?._id}
            onRow={(record) => {
              return {
                onClick: () => {
                  onRowClick(record?._id);
                },
              };
            }}
          />
        </Skeleton>
      </div>
    </Dashboard>
  );
};

export default Orders;
